import { apiLogger } from "../../utils/logger";import axios, { AxiosInstance, AxiosError } from 'axios';
import { authService } from './authService';
import useAppStore from '../../stores/useAppStore';

// Create API client
const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://your-cloudfront-domain.com/api',
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const token = await authService.getJwtToken();
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // If we can't get a token, continue without it
      // This allows unauthenticated requests (like registration)
      apiLogger.warn('Could not get JWT token for request:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    // Handle authentication errors (token invalid/expired)
    if (error.response && error.response.status === 401) {
      apiLogger.warn('Token invalid/expired - logging out user');
      
      try {
        // Sign out from Cognito
        await authService.signOut();
      } catch (signOutError) {
        apiLogger.error('Error signing out:', signOutError);
      }
      
      // Update app state to logout user
      useAppStore.getState().logout();
      
      // Only redirect if we're not already on a public page
      const currentPath = window.location.pathname;
      const publicPaths = ['/', '/login', '/register'];
      
      if (!publicPaths.includes(currentPath)) {
        // Redirect to home page
        window.location.href = '/';
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
